import { render } from "./ArrowDownSmall.vue?vue&type=template&id=b3dae174"
import script from "./ArrowDownSmall.vue?vue&type=script&lang=js"
export * from "./ArrowDownSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__